export const never = (arg: never): never => {
  throw new Error(`Unexpected value in never: ${arg}`);
};
